export enum RequestInformationDisabledReasonEnum {
  FEATURE_DISABLED = "FEATURE_DISABLED",
  CLIENT_EMAIL_REQUIRED = "CLIENT_EMAIL_REQUIRED",
  CLIENT_EXTERNAL_USER_ID_REQUIRED = "CLIENT_EXTERNAL_USER_ID_REQUIRED"
}
